import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';

@Component({
    selector: 'app-arc-percentage-lable',
    templateUrl: './arc-percentage-lable.component.html',
    styleUrls: ['./arc-percentage-lable.component.scss']
})
export class ArcPercentageLableComponent implements OnInit {
    
    @Input() percentage = 0; 
    @Input() label = 'none';
    @Input() selectedBaladyas :any =['مكتملة']
    @Input() max = 100; 
    @Input() radius = 100;
    @Input() stroke = 22;
    @Input() semicircle = 'true';

    constructor() {}
 
    getNum()
    {
        return parseInt(this.percentage?.toString()??'0');
    }
    ngOnInit() {}
    
}
